export const factorConstants = {
    SELECT_FACTORS_TAB: 'SELECT_FACTORS_TAB',
    SELECT_FACTOR_HISTORY_FILTER: 'SELECT_FACTOR_HISTORY_FILTER',
    CLEAR_FACTOR_HISTORY_FILTER: 'CLEAR_FACTOR_HISTORY_FILTER'
}
